import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import RoutingService from '../../../services/RoutingService';
import { ProfileTypes } from '../../Types';
import FileConstants from '../../../constants/FileConstants';
import CameraService from '../../../services/CameraService';
// import AuthService from '../../../services/AuthService';

export function handleAgeSubmission() {
  RoutingService.gotoOnboardMobileInput();
}
export function handleGenderSubmission() {
  setTimeout(() => {
    RoutingService.gotoAgeEntry();
  }, 300);
}

export function handleProfileInfo(state, profileInfo) {
  console.log({ state, profileInfo });
}

export function redirectByProfileDetails(data, dispatch) {
  console.log('data: ', data);
  /**
   * Updating Profile
   */
  if (isEmpty(get(data, 'userInformation'))) {
    RoutingService.gotoOnboardLanguageSelection();
    return false;
  }

  dispatch({ type: ProfileTypes.PROFILE_PATCH_RESPONSE, payload: data });

  const userWorkLocalities = get(data, 'userWorkLocalities');
  if (!userWorkLocalities || userWorkLocalities.length === 0) {
    return RoutingService.gotoAreaSelection();
  }
  return RoutingService.gotoHome();
}

export function getImageFile(source, isBlob, isSelfie) {
  const settings = { blobData: isBlob, isSelfie };
  if (source === FileConstants.SOURCE_CAMERA) {
    return CameraService.openCamera(settings);
  }
  return CameraService.openFile(settings);
}
